<script>
  import { PUBLIC_SUPABASE_URL } from '$app/env/public';
</script>
<div class="link">
  <h5>gramjam.app</h5>

  <img
    src={`${PUBLIC_SUPABASE_URL}/storage/v1/object/public/public-assets/logo-mini.png`}
    alt="favicon"
    width="80px"
    height="74px"
  />
</div>

<style
  lang="scss"
>
  @use '../theme/theme';
  .link {
    font-weight: 600;
    font-size: 42px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    font-weight: 600;
    color: theme.$daily-vertical-dark;
    text-decoration: underline;
    :global(html.dark-mode) & {
      color: theme.$daily-vertical-light;
    }
  }
</style>
